import React from "react";
import { Checkout } from "tsi-common-react/src/apps/checkout/Checkout/index";
import { registerCheckoutCascades } from "tsi-common-react/src/apps/checkout/cascades-checkout";

import { store } from "../../store";
import { BasketSidebarContent } from "./BasketSidebarContent";

// Checkout-specific store cascades, registered once when this client-only
// module loads -- before the Checkout component first renders, mirroring the
// original placement inside the checkout app mount. Loaded only on the client
// (via CheckoutApp's React.lazy import); the checkout dependency tree is not
// SSR-safe. The reactivated renderer + the client entry already wrap the
// document in the Redux Provider, so no Provider is needed here.
registerCheckoutCascades(store);

// The ErrorBoundary lives in CheckoutApp (wrapping Suspense) so it also catches
// chunk-load failures of this lazy module.
const CheckoutAppInner = (): React.JSX.Element => (
    <Checkout
        getExtraSummaryContent={() => {
            return null;
        }}
        getExtraSidebarContent={() => {
            return <BasketSidebarContent />;
        }}
        buildFinancingUpsell={() => {
            return null;
        }}
    />
);

export default CheckoutAppInner;
